var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('meta-manager',{attrs:{"current-query-params":_vm.currentQueryParams}},[_c('meta-info-injector',{attrs:{"meta":_vm.meta}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }